import { Component, Input } from '@angular/core';
import { ConfirmationFormService } from '../confirmation-form.service';
import { OFFICE_PHONE } from '../shared/constants/phone-number.constant';
import { BankAccount } from '../shared/models/profile-result.model';
export class ConfirmationBankAccountComponent {
public bankData: BankAccount;
public isShowPhoneNumber: boolean = false;
public OFFICE_PHONE: any = OFFICE_PHONE;
/**
 * @param {?} parentService
 */
constructor(public parentService: ConfirmationFormService) {}
/**
 * @return {?}
 */
togglePhoneNumber() {
    this.isShowPhoneNumber = !this.isShowPhoneNumber;
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'confirmation-bank-account',
  template: `
    <div class="tnk-card">
      <div class="tnk-card__header">
        <h1>Rekening Bank</h1>
        <div>
          <small>Langkah 2 dari 4</small>
        </div>
      </div>
      <div class="tnk-card__body">
        <div class="tnk-padding">
          <div class="main-content">
            <div>
              <label class="control-label">Nama Bank</label>
              <p>
                {{ bankData.bankName }}
              </p>

              <label class="control-label">Nomor Rekening</label>
              <p>
                {{ bankData.accountNumber }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="info-card padding-15">
      <span>
        Hubungi kami jika ingin mengubah akun Rekening Bank Anda.
        <a
          class="info-card--mobile-view"
          id="LinkPhoneNumberMobileView"
          href="tel:{{ OFFICE_PHONE.area }}{{ OFFICE_PHONE.phone }}"
        >
          Silahkan klik disini
        </a>
        <a
          class="info-card--desktop-view"
          id="LinkPhoneNumberWebView"
          (click)="togglePhoneNumber()"
        >
          Silahkan klik disini
        </a>
      </span>
    </div>

    <div class="tnk-card__nav">
      <div class="tnk-padding">
        <div class="row">
          <div class="col-xs-6">
            <button
              id="BtnPrevStep"
              class="tnk-button__green block"
              (click)="parentService.prevStep()"
            >
              Sebelumnya
            </button>
          </div>
          <div class="col-xs-6">
            <button
              (click)="parentService.nextStep()"
              id="BtnNextStep"
              class="tnk-button__green block active right"
            >
              Selanjutnya
            </button>
          </div>
        </div>
      </div>
    </div>

    <tnk-modal [isOpen]="isShowPhoneNumber">
      <tnk-modal-body>
        <p>
          Untuk mengubah Rekening Bank, silahkan hubungi Call Center kami di
          <strong>{{ OFFICE_PHONE.area }}-{{ OFFICE_PHONE.phone }}</strong>
        </p>
      </tnk-modal-body>
      <tnk-modal-footer>
        <button
          id="BtnCloseModalToggelPhoneNumber"
          class="tnk-button tnk-button--primary tnk-button--full-width"
          (click)="togglePhoneNumber()"
        >
          Tutup
        </button>
      </tnk-modal-footer>
    </tnk-modal>
  `,
  styles: [`
    .tnk-card {
      background: #fdfdfd;
      border-left: 5px solid #ffc412;
      border-radius: 5px;
      color: #535353;
      margin-bottom: 15px; }
      .tnk-card__nav {
        margin: 15px 0; }
      .tnk-card__header {
        border-bottom: 1px solid #e1e1e1;
        padding: 15px;
        -ms-flex-flow: wrap;
            flex-flow: wrap; }
        .tnk-card__header h1 {
          font-size: 16px;
          margin: 0;
          width: 100%; }
        .tnk-card__header small {
          font-size: 12px;
          color: #9b9b9b;
          width: 100%; }
      .tnk-card__body {
        padding: 10px 0; }
        .tnk-card__body .exampling-container__item {
          background: #f4f4f4;
          border-radius: 10px;
          padding: 10px;
          margin: 5px 0 15px 0;
          text-align: center; }
          .tnk-card__body .exampling-container__item-row {
            display: -webkit-box;
            display: -ms-flexbox;
            display: flex;
            -webkit-box-orient: horizontal;
            -webkit-box-direction: normal;
                -ms-flex-direction: row;
                    flex-direction: row;
            justify-items: center;
            -webkit-box-pack: center;
                -ms-flex-pack: center;
                    justify-content: center;
            margin: 0 auto; }
          .tnk-card__body .exampling-container__item .img-padding {
            padding: 4px; }
          .tnk-card__body .exampling-container__item .exampling-img {
            margin: 5px 0 10px 0; }
            .tnk-card__body .exampling-container__item .exampling-img.text-red {
              color: #ff0000; }
            .tnk-card__body .exampling-container__item .exampling-img.text-green {
              color: #80bd01; }
            .tnk-card__body .exampling-container__item .exampling-img img {
              margin: 0 auto;
              height: 100px; }
            .tnk-card__body .exampling-container__item .exampling-img h4 {
              margin: 5px 0;
              font-size: 12px;
              font-weight: bolder; }
          .tnk-card__body .exampling-container__item h2 {
            font-size: 14px;
            margin: 0 0 10px 0;
            text-align: center;
            font-weight: bolder; }
          .tnk-card__body .exampling-container__item small {
            font-size: 12px;
            margin: 5px 0; }
        .tnk-card__body .exampling-container__preview img {
          max-width: 150px; }
        .tnk-card__body .exampling-container__error p {
          color: #ff0000;
          padding-bottom: 10px; }
        .tnk-card__body .cancel-content form div {
          margin: 15px 0; }
        .tnk-card__body .form-group p {
          font-size: 12px;
          margin: -7px 0 4px 0; }
        .tnk-card__body h1 {
          margin: 0;
          font-size: 16px;
          font-weight: bolder;
          line-height: 21px; }
        .tnk-card__body h4 {
          margin: 0;
          font-size: 12px; }
        .tnk-card__body ul {
          padding: 0;
          margin: 0; }
          .tnk-card__body ul li:not(.tnk-li) {
            list-style-type: none; }
        .tnk-card__body ul.tnk-ul {
          margin-left: 15px; }
        .tnk-card__body strong {
          font-weight: bolder; }
        .tnk-card__body p {
          font-size: 14px;
          line-height: 21px; }
        .tnk-card__body p.tnk-confirmation--p {
          font-size: 16px; }
        .tnk-card__body small {
          font-size: 12px; }

    .p-t {
      padding-top: 10px; }

    .p-b {
      padding-bottom: 10px; }

    .p-y {
      padding: 5px 0px; }

    .p-x {
      padding: 0px 5px; }

    .tnk-button__blue {
      width: 120px;
      color: #0087c6;
      background-color: #fdfdfd;
      border: 2.5px solid #0087c6;
      border-radius: 5px;
      line-height: 13px;
      padding: 5px;
      margin: 5px 0; }
      .tnk-button__blue.active {
        color: #fdfdfd;
        background-color: #0087c6; }
      .tnk-button__blue.disabled {
        color: #e1e1e1;
        cursor: not-allowed;
        background-color: #9b9b9b;
        border-color: #9b9b9b; }
      .tnk-button__blue.block {
        width: 100%;
        max-width: 180px;
        text-transform: capitalize;
        padding: 13px 0 10px 0;
        text-align: center; }

    .tnk-button__green {
      width: 120px;
      color: #80bd01;
      background-color: #fdfdfd;
      border: 2.5px solid #80bd01;
      border-radius: 5px;
      line-height: 13px;
      padding: 5px;
      margin: 5px 0; }
      .tnk-button__green.active {
        color: #fdfdfd;
        background-color: #80bd01; }
      .tnk-button__green.disabled {
        color: #e1e1e1;
        cursor: not-allowed;
        background-color: #9b9b9b;
        border-color: #9b9b9b; }
      .tnk-button__green.block {
        width: 100%;
        max-width: 180px;
        text-transform: capitalize;
        padding: 13px 0 10px 0;
        text-align: center; }
      .tnk-button__green.right {
        float: right; }

    .info-card {
      width: 100%;
      background-color: #fffcdb; }

    .info-card--mobile-view {
      display: none; }

    .info-card--desktop-view {
      display: inline; }

    @media (max-width: 768px) {
      .info-card--mobile-view {
        display: inline; }
      .info-card--desktop-view {
        display: none; } }
  `],
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ConfirmationFormService, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'bankData': [{ type: Input },],
};
}

function ConfirmationBankAccountComponent_tsickle_Closure_declarations() {
/** @type {?} */
ConfirmationBankAccountComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ConfirmationBankAccountComponent.ctorParameters;
/** @type {?} */
ConfirmationBankAccountComponent.propDecorators;
/** @type {?} */
ConfirmationBankAccountComponent.prototype.bankData;
/** @type {?} */
ConfirmationBankAccountComponent.prototype.isShowPhoneNumber;
/** @type {?} */
ConfirmationBankAccountComponent.prototype.OFFICE_PHONE;
/** @type {?} */
ConfirmationBankAccountComponent.prototype.parentService;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
